export type ClientSetting = {
  id: ClientIds
  productName: string
}

export type ClientIds = 'default' | 'pharmacy-support-web'

export const clientSettings: Record<ClientIds, ClientSetting> = {
  default: {
    id: 'default',
    productName: '__NAME__',
  },
  'pharmacy-support-web': {
    id: 'pharmacy-support-web',
    productName: 'PharmacySupportWeb',
  },
}

const COOKIE_LOGIN_CLIENT_ID_PHARMACY_SUPPORT_WEB = 'pharmacy-support-web'

export const getClientSettingByCookieLoginClientId = (clientId: string) => {
  if (clientId === COOKIE_LOGIN_CLIENT_ID_PHARMACY_SUPPORT_WEB) {
    return clientSettings['pharmacy-support-web']
  }

  return null
}

export const getHeadMetaTitle = (clientId: ClientIds) => {
  switch (clientId) {
    case 'pharmacy-support-web':
    default:
      return 'クロンお薬サポート'
  }
}
